import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CircularProgress } from '@mui/material';
import rootApi from '@utils/baseAPI/WrapperApi';
import { useMutation } from 'react-query';
import { showError, showSuccess } from '@components/notification';

const DialogUnbindPartner = (props) => {
  const { users, depotCode, openUnbin, setOpenUnbin, refetch } = props;
  const { mutateAsync, isLoading } = useMutation('stop-transaction', () => {
    return rootApi.put(`/admin/depots/${depotCode}/unbind-to-partner/${users?.id}`);
  });

  const handleClose = () => {
    refetch();
    setOpenUnbin(false);
  };

  const handleDelete = () => {
    mutateAsync()
      .then(() => {
        handleClose();
        showSuccess({ message: 'Gõ đối tác khỏi trạm thành công' });
      })
      .catch((error) => {
        showError(error || 'Vui lòng liên hệ admin để được hỗ trợ');
      });
  };

  return (
    <Dialog
      open={openUnbin}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Thông báo</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ display: 'flex' }}>
          Bạn có chắc chắn muốn gỡ đối tác khỏi trạm không?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDelete} variant="contained" color="primary" disabled={isLoading}>
          {isLoading && <CircularProgress size={10} />} Đồng ý
        </Button>
        <Button onClick={handleClose} autoFocus variant="contained" color="inherit">
          Hủy
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogUnbindPartner;
